import "antd/lib/card/style";
import _Card from "antd/lib/card";
import "antd/lib/table/style";
import _Table from "antd/lib/table";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/empty/style";
import _Empty from "antd/lib/empty";
import "antd/lib/space/style";
import _Space from "antd/lib/space";
import "antd/lib/typography/style";
import _Typography from "antd/lib/typography";
var __jsx = React.createElement;
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import ExploreSelect from 'components/repository/ExploreSelect';
import { modules } from 'utils/constants';
import { useAppRouter } from 'utils/AppRouteProvider';
import { techNamesToDisplay } from 'utils/upload/fileUploadUtils';
var Paragraph = _Typography.Paragraph;
var RepositoryTable = function RepositoryTable(props) {
  // Make ready-to-use rows for the table
  // e.g. turn sourceTitle+sourceUrl into a single <a> tag, etc.
  var formatData = function formatData(data) {
    return data.map(function (row) {
      return {
        key: row.id,
        name: row.name,
        explore: __jsx(ExploreSelect, {
          experiment: row
        }),
        publication: __jsx("a", {
          href: row.publicationUrl
        }, row.publicationTitle),
        dataSource: __jsx("a", {
          href: row.dataSourceUrl
        }, row.dataSourceTitle),
        species: row.species,
        sampleCount: row.sampleCount,
        cellCount: row.cellCount,
        sampleTechnology: techNamesToDisplay[row.sampleTechnology],
        description: row.description
      };
    });
  };
  var data = props.data;
  var formattedData = formatData(data);
  var _useAppRouter = useAppRouter(),
    navigateTo = _useAppRouter.navigateTo;
  var onCloseTable = function onCloseTable() {
    navigateTo(modules.DATA_MANAGEMENT);
  };
  var locale = {
    emptyText: __jsx(_Empty, {
      imageStyle: {
        height: 60
      },
      description: __jsx(_Space, {
        size: "middle",
        direction: "vertical"
      }, __jsx(Paragraph, null, "There are no experiments in the repository yet."))
    })
  };
  return __jsx(_Card, {
    title: "Public Datasets Repository",
    extra: __jsx(_Button, {
      onClick: onCloseTable
    }, __jsx(CloseOutlined, null))
  }, __jsx(_Table, {
    dataSource: formattedData,
    columns: TABLE_COLUMNS,
    locale: locale,
    showHeader: formattedData.length > 0,
    pagination: false
  }));
};
RepositoryTable.defaultProps = {
  data: []
};
var TABLE_COLUMNS = [{
  title: '',
  dataIndex: 'explore',
  key: 'explore'
}, {
  title: 'Dataset name',
  dataIndex: 'name',
  key: 'name'
}, {
  title: 'Publication',
  dataIndex: 'publication',
  key: 'publication'
}, {
  title: 'Data Source',
  dataIndex: 'dataSource',
  key: 'dataSource'
}, {
  title: 'Species',
  dataIndex: 'species',
  key: 'species'
}, {
  title: 'Sample Count',
  dataIndex: 'sampleCount',
  key: 'sampleCount'
}, {
  title: 'Cell Count Estimate',
  dataIndex: 'cellCount',
  key: 'cellCount'
}, {
  title: 'Technology',
  dataIndex: 'sampleTechnology',
  key: 'sampleTechnology'
}, {
  title: 'Short description',
  dataIndex: 'description',
  key: 'description'
}];
export default RepositoryTable;